/* eslint-disable react-hooks/exhaustive-deps */
import React, { FunctionComponent, useMemo } from "react";
import AssetsContext, { AssetsContextValue } from "contexts/AssetsContext";
import useFancyBearsInWallet from "hooks/useFancyBearsInWallet";
import useHoneyJarsInWallet from "hooks/useHoneyJarsInWallet";
import useGoldlistStatus from "hooks/useGoldlistStatus";
import useConnectedAccount from "hooks/useConnectedAccount";
import useFormattedBalance from "hooks/useFormattedBalance";

const AssetsProvider: FunctionComponent = ({ children }) => {
  const [address] = useConnectedAccount();
  const [fancyBearsInWallet, readFancyBearsClaimStatusByAddress] =
    useFancyBearsInWallet(address);

  const [honeyJarsInWallet, readHoneyJarsInWallet] =
    useHoneyJarsInWallet(address);

  const [goldlistClaimedCount, goldlistMaxClaim, readGoldlistClaimedCount] =
    useGoldlistStatus(address);

  const formattedBalance = useFormattedBalance(address);

  const contextValue = useMemo<AssetsContextValue>(
    () => ({
      formattedBalance,
      fancyBearsInWallet,
      fancyBearsInWalletCount: fancyBearsInWallet?.length,
      honeyJarsInWallet,
      honeyJarsInWalletCount: honeyJarsInWallet?.length,
      goldlistClaimedCount,
      goldlistMaxClaim,
      readFancyBearsClaimStatusByAddress,
      readHoneyJarsInWallet,
      readGoldlistClaimedCount,
    }),
    [
      formattedBalance,
      fancyBearsInWallet,
      honeyJarsInWallet,
      goldlistClaimedCount,
    ]
  );

  return (
    <AssetsContext.Provider value={contextValue}>
      {children}
    </AssetsContext.Provider>
  );
};

export default AssetsProvider;
